import { TEAM_FEED_PAGE, TEAM_FEED_PATH_PREFIX } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const teamUpdatesViewRoute = createGlobalRoute({
	exact: true,
	name: TEAM_FEED_PAGE,
	path: `${TEAM_FEED_PATH_PREFIX}/:id`,
	layout: 'home',
	subproduct: 'townsquare-people-team-directory',
});
